import { render, staticRenderFns } from "./VrstaSuorganizatoraBase.vue?vue&type=template&id=8e0aa68a&scoped=true&"
import script from "./VrstaSuorganizatoraBase.vue?vue&type=script&lang=js&"
export * from "./VrstaSuorganizatoraBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0aa68a",
  null
  
)

export default component.exports